




































































import { apiClient } from "@/services/api-client";
import { mapGetters } from "vuex";
import LoadingBlock from "@/components/LoadingBlock.vue";
import BestellijstNewLijst from "@/components/BestellijstNewLijst.vue";

export default {
  name: "BestellijstenToevoegen",
  components: { BestellijstNewLijst, LoadingBlock },
  props: {
    buttonIsDisabled: {
      type: Boolean,
      default: false
    },
    useCartIcon: {
      type: Boolean,
      default: false
    },
    buttonClass: {
      type: String,
      default: "btn btn-outline-primary btn-block"
    },
    items: null
  },
  data() {
    return {
      isLoading: false,
      favorieten: [],
      isNew: false,
      showModal: false,
      isInList: false
    };
  },
  computed: {
    ...mapGetters([
      "getUsername",
      "isAuthenticated",
      "getBestelLijsten",
      "getBestelLijstenLocatie",
      "getBoolSetting"
    ])
  },
  methods: {
    add(id) {
      if (this.items.length > 0) {
        //split array -> extract set objects
        var sets = this.items.filter(obj => obj.isSet);
        var individualItems = this.items.filter(obj => !obj.isSet);

        if (individualItems.length > 0) {
          this.$store
            .dispatch("bestellijstItemDetailsToegevoegdLijst", {
              items: individualItems,
              bestelijstId: id
            })
            .then(response => {
              // this.$refs.modal.hide();
              //this.isInList = true;
            });
        }

        if (sets.length > 0) {
          var mainsets = sets.some(set => set.isMainSet);
          //add as custom set
          if (this.getBoolSetting("Sets_AllowEdit") && !mainsets) {
            sets.forEach(set => {
              set.setItems = set.setItems.map(item => {
                return {
                  aantal: item.aantal,
                  materieelSoort: item.materieelSoort,
                  setNummer: set.setNummer
                };
              });
            });

            this.$store.dispatch("bestellijstSetToegevoegd", {
              sets: sets,
              bestellijstId: id
            });
          } else {
            //add as mainsets
            this.$store.dispatch("bestellijstMainSetToegevoegd", {
              sets: sets,
              bestellijstId: id
            });
          }
        }
        this.$refs.modal.hide();
        this.$emit("resetAantallen");
      } else {
        this.$store.dispatch("snackbarAdded", {
          text: this.$t("shared.lege_lijst"),
          type: "warning"
        });
      }
    }
  }
};
